export default {"src":"/_next/static/media/shipping4.f4383842.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};